export enum featureConfig {
  ENVIRONMENTS = 'environments',
  RECOMENDADOS_BUMI = 'cvs_recomendados_bumi_enabled',
  DIRECCION_AUTOCOMPLETE = 'new_aviso_publicacion_direccion_autocomplete',
  SELECTA = 'selecta_enabled',
  AVISO_NIVELES_LABORALES_RESTRINGIDOS = 'aviso_niveles_laborales_restringidos',
  AVISO_HUNTER = 'aviso_hunter',
  AVISO_HUNTER_EMPRESAS = 'aviso_hunter_empresas',
  AVISO_CONECTA_LIMITAR_AREA = 'restricted_areas_conecta',
  ESTADISTICAS_EMPRESAS = 'estadisticas_empresas',
  ESTADISTICAS_COMPARATIVAS_EMPRESAS = 'estadisticas_comparativas_empresas',
  ESTADISTICAS_VISTAS_EMPRESAS = 'estadisticas_vistas_empresas',
  JOBI = 'jobi_enabled',
  JOBI_EMPRESAS = 'jobi_empresas',
  HOME_HIDDEN_PRICES_PRODUCTS = 'home_hidden_prices',
  ENCABEZADO_AVISOS = 'encabezado_avisos',
  BENEFICIOS_AVISOS = 'beneficios_avisos',
  ENCABEZADO_PERFIL = 'encabezado_perfil',
  BENEFICIOS_PERFIL = 'beneficios_perfil',
  DASHBOARD_DEFAULT = 'dashboard_default',
  BANNER_GRATIS = 'banner_gratis',
  ECOMMERCE_DISABLED_ITEMS = 'disabled_ecommerce_items',
  PRODUCTOS_CARACTERISTICAS = 'caracteristicas',
  BUSQUEDA_EN_BASE = 'busqueda_en_base',
  AVISO_TAG_NEW = 'aviso_tag_new',
  AVISO_PALABRAS_RESTRINGIDAS = 'aviso_palabras_restringidas',
  PUBLICACION_SIN_REVISION_MANUAL = 'publicacion_sin_revision_manual',
  MODAL_UPGRADE_EXPRESS = 'modal_upgrade_express',
  AVISO_CUPON = 'aviso_cupon',
  AVISOS_CON_RECOMENDADOS = 'avisos_con_recomendados',
  AVISOS_CON_SUGERIDOS = 'avisos_con_sugueridos',
  EMPRESAS_SOBRECARGADAS = 'empresas_sobrecargadas',
  PANEL_EMPRESAS = 'panel_empresas',
  PANEL_EMPRESAS_CONSULTORAS = 'panel_empresas_consultoras',
  NEW_SEARCH_BAR = 'new_search_bar',
  PROVINCIA_SAP_REGISTRO = 'provincia_sap_registro',
  MENSAJES_EMPRESAS = 'mensajes_empresas',
  MENSAJES_EMPRESAS_LANDING = 'mensajes_empresas_landing',
  MENSAJES_EMPRESAS_LANDING_FULLPAGE = 'mensajes_empresas_landing_fullpage',
}
